/*
 * @Author: Merlin
 * @Date: 2024-03-15 17:32:31
 * @LastEditors: Merlin
 * @LastEditTime: 2024-03-20 10:56:08
 * @Description:
 */

import sfootStepPic from '../img/footstep.png';

class h01 {
    constructor(t, s, i) {
        (this.steps = t);
        (this.poseIndex = s);
        (this.alpha = 1);
        (this.poses = i);
        (this.pos = i[s]);
        (this.alpha = 0.5 + 0.25 * s);
        (this.initX = s);
        (this.alphaSpeed = 0.25 / 20);
    }
    restart() {
        let t = null;
        for (let s = this.poseIndex + 1; s < this.poses.length; s++){
            if (this.steps.find((i) => i.poseIndex === s) === void 0) {
                t = s;
                break;
            }
        }
        if (t === null) {
            for (let s = 0; s < this.poses.length; s++) {
                if (this.steps.find((i) => i.poseIndex === s) === void 0) {
                    t = s;
                    break;
                }
            }
        }
        (this.poseIndex = t);
        (this.pos = this.poses[t]);
        (this.alpha = 1.75);
    }
    update() {
        (this.alpha -= this.alphaSpeed);
        if (this.alpha < 0){
            this.restart();
        }
    }
    // 1参是 canvas context, 2参是图像
    redraw(t, s) {
        const [i, n, p, c, d, l] = this.pos;
        t.save();
        (t.globalAlpha = this.alpha);
        t.setTransform(i, n, p, c, d, l);
        t.drawImage(s, 0, 0, s.width, s.height, 0, 0, s.width, s.height);
        t.restore();
    }
}

// ↓ 生成脚印动画 
export class b02 {
    constructor() {
        (this.live = true);
        (this.stepsAnimate1 = []);
        (this.stepsAnimate2 = []);
        (this.stepsAnimate3 = []);
        const {g, w, S} = getStepArr();
        for (let t = 0; t < 6; t++){
            this.stepsAnimate1.push(new h01(this.stepsAnimate1, t, g));
            this.stepsAnimate2.push(new h01(this.stepsAnimate2, t, w));
            this.stepsAnimate3.push(new h01(this.stepsAnimate3, t, S));
        }
    }
    // 1参 t 是 cavas dom 
    // 2参 s 是 脚印图形 
    init(t) {
        this.footStepImg = Object.assign(new Image(), {
            src: sfootStepPic,
        });
        (this.live = true);
        (this.canvas = t);
        (this.ctx = t.getContext('2d'));
    }
    update() {
        this.stepsAnimate1.forEach((t) => t.update());
        this.stepsAnimate2.forEach((t) => t.update());
        this.stepsAnimate3.forEach((t) => t.update());
    }
    redraw() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.stepsAnimate1.forEach((t) => t.redraw(this.ctx, this.footStepImg));
        this.stepsAnimate2.forEach((t) => t.redraw(this.ctx, this.footStepImg));
        this.stepsAnimate3.forEach((t) => t.redraw(this.ctx, this.footStepImg));
    }
}


// ↓ 数据
export function getStepArr(){
    const g = [
        [0.68, -0.74, 0.74, 0.68, 55.3, 118.55],
        [0.57, -0.82, 0.82, 0.57, 73.75, 183.95],
        [0.66, -0.75, 0.75, 0.66, 150.1, 202.15],
        [0.59, -0.81, 0.81, 0.59, 166.25, 277.5],
        [0.34, -0.94, 0.94, 0.34, 231.85, 295.5],
        [-0.03, -1, 1, -0.03, 283.6, 345.15],
        [-0.38, -0.93, 0.93, -0.38, 340.7, 318.45],
        [-0.5, -0.87, 0.87, -0.5, 404.2, 319.5],
        [-0.73, -0.68, 0.68, -0.73, 418.65, 270.35],
        [-0.85, -0.53, 0.53, -0.85, 471.7, 240.9],
        [-0.92, -0.38, 0.38, -0.92, 465.85, 190.15],
        [-0.97, -0.24, 0.24, -0.97, 502.75, 134.65],
        [-1, -0.06, 0.06, -1, 492.65, 79.4],
    ],
    w = [
        [-1, 0.08, -0.08, -1, 407.8, 955.45],
        [-1, 0.08, -0.08, -1, 433.15, 908.35],
        [-0.97, 0.22, -0.22, -0.97, 401.8, 867.9],
        [-0.97, 0.22, -0.22, -0.97, 418.65, 810.3],
        [-0.97, 0.22, -0.22, -0.97, 383.35, 772.15],
        [-0.97, 0.22, -0.22, -0.97, 400, 714.8],
        [-0.95, 0.32, -0.32, -0.95, 361.1, 687.8],
        [-0.95, 0.32, -0.32, -0.95, 369.3, 623.05],
        [-0.91, 0.42, -0.42, -0.91, 329.2, 604.3],
        [-0.49, 0.87, -0.87, -0.49, 323.7, 536.05],
        [-0.27, 0.96, -0.96, -0.27, 274.3, 553.15],
        [0.25, 0.97, -0.97, 0.25, 210.95, 511.65],
        [0.4, 0.92, -0.92, 0.4, 179.95, 563],
        [0.4, 0.92, -0.92, 0.4, 121.75, 556.35],
        [0.03, 1, -1, 0.03, 90, 612.3],
        [-0.28, 0.96, -0.96, -0.28, 55.6, 585.5],
    ],
    S = [
        [0.64, 0.76, -0.76, 0.64, 1255.75, 144.9],
        [0.81, 0.59, -0.59, 0.81, 1233.25, 199.15],
        [0.69, 0.73, -0.73, 0.69, 1182.55, 205.45],
        [0.82, 0.57, -0.57, 0.82, 1172.55, 262.8],
        [0.97, 0.24, -0.24, 0.97, 1114.95, 281.85],
        [0.99, 0.11, -0.11, 0.99, 1123, 339.9],
        [1, 0.02, -0.02, 1, 1103, 394.7],
        [0.98, -0.21, 0.21, 0.98, 1132.3, 455.15],
        [1, -0.08, 0.08, 1, 1099.95, 496.6],
        [1, 0.02, -0.02, 1, 1136.75, 555.2],
        [0.83, 0.56, -0.56, 0.83, 1091.5, 582.05],
        [0.9, 0.44, -0.44, 0.9, 1084.2, 639.7],
        [0.97, 0.25, -0.25, 0.97, 1032.8, 677.05],
        [0.99, 0.14, -0.14, 0.99, 1057.7, 720.55],
        [0.97, 0.25, -0.25, 0.97, 1026.6, 779.75],
        [1, 0.08, -0.08, 1, 1032.35, 836.7],
        [1, 0.08, -0.08, 1, 1001.4, 887.95],
        [1, -0.03, 0.03, 1, 1019.45, 937.45],
    ];
    return {g, w, S};
}




